import { render, staticRenderFns } from "./PaymentCardPlaceholder.vue?vue&type=template&id=f4a6e566"
import script from "./PaymentCardPlaceholder.vue?vue&type=script&lang=ts"
export * from "./PaymentCardPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4a6e566')) {
      api.createRecord('f4a6e566', component.options)
    } else {
      api.reload('f4a6e566', component.options)
    }
    module.hot.accept("./PaymentCardPlaceholder.vue?vue&type=template&id=f4a6e566", function () {
      api.rerender('f4a6e566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skeletonPlaceholder/components/PaymentCardPlaceholder.vue"
export default component.exports